import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import QuickActionToolbar from '../../components/ui/QuickActionToolbar';
import Icon from '../../components/AppIcon';


import Select from '../../components/ui/Select';
import CompanySettings from './components/CompanySettings';
import AccountingSettings from './components/AccountingSettings';
import UsersPermissions from './components/UsersPermissions';
import IntegrationSettings from './components/IntegrationSettings';
import NotificationSettings from './components/NotificationSettings';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('company');
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const tabs = [
    { id: 'company', label: 'Company', icon: 'Building2' },
    { id: 'accounting', label: 'Accounting', icon: 'Calculator' },
    { id: 'users', label: 'Users & Permissions', icon: 'Users' },
    { id: 'integrations', label: 'Integrations', icon: 'Plug' },
    { id: 'notifications', label: 'Notifications', icon: 'Bell' }
  ];

  const quickActions = [
    {
      label: 'Save Changes',
      onClick: () => {
        console.log('Saving settings...');
        setHasUnsavedChanges(false);
      },
      variant: 'default',
      icon: 'Save',
      disabled: !hasUnsavedChanges
    },
    {
      label: 'Reset',
      onClick: () => {
        console.log('Resetting settings...');
        setHasUnsavedChanges(false);
      },
      variant: 'outline',
      icon: 'RotateCcw'
    }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'company':
        return <CompanySettings onChange={() => setHasUnsavedChanges(true)} />;
      case 'accounting':
        return <AccountingSettings onChange={() => setHasUnsavedChanges(true)} />;
      case 'users':
        return <UsersPermissions onChange={() => setHasUnsavedChanges(true)} />;
      case 'integrations':
        return <IntegrationSettings onChange={() => setHasUnsavedChanges(true)} />;
      case 'notifications':
        return <NotificationSettings onChange={() => setHasUnsavedChanges(true)} />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <QuickActionToolbar actions={quickActions} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Page Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
          <p className="mt-2 text-sm text-gray-600">
            Configure your AccountingPro system preferences and business settings
          </p>
        </div>

        {/* Unsaved Changes Warning */}
        {hasUnsavedChanges && (
          <div className="mb-6 bg-warning/10 border border-warning rounded-lg p-4 flex items-center gap-3">
            <Icon name="AlertTriangle" size={20} className="text-warning" />
            <p className="text-sm text-warning-foreground">
              You have unsaved changes. Don't forget to save before leaving this page.
            </p>
          </div>
        )}

        {/* Tabs Navigation */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          {/* Desktop Tabs */}
          <div className="hidden md:flex border-b border-gray-200">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === tab?.id
                    ? 'border-primary text-primary bg-primary/5' :'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                <Icon name={tab?.icon} size={18} />
                {tab?.label}
              </button>
            ))}
          </div>

          {/* Mobile Tabs */}
          <div className="md:hidden border-b border-gray-200 p-4">
            <Select
              value={activeTab}
              onChange={setActiveTab}
              options={tabs?.map(tab => ({
                value: tab?.id,
                label: tab?.label
              }))}
            />
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;